import {
  ADD,
  REMOVE,
  SET_LAYOUT_CONFIG,
  SET_USER_THEME_OPTIONS,
  SET_DEFAULT_THEME,
  SET_AVAILABLE_LOCALES,
  SET_QUERY_LOCALE,
} from './consts';
export default {
  [ADD](state, data) {
    state.messages.push(data);
  },

  [REMOVE](state, id) {
    console.log('remove id', id);
    state.messages = state.messages.filter(m => m.id !== id);
  },

  // Different layout options, for example - hide footer;
  [SET_LAYOUT_CONFIG](state, payload) {
    state.layoutConfig = payload;
  },
  [SET_USER_THEME_OPTIONS](state, payload) {
    state.customThemeOptions = payload;
  },

  [SET_DEFAULT_THEME](state, payload) {
    state.selectedTheme = payload;
  },

  [SET_AVAILABLE_LOCALES](state, payload) {
    state.availableLocales = payload;
  },

  [SET_QUERY_LOCALE](state, payload) {
    state.queryLocale = payload;
  },
};
